/** Partnership evidence levels (Anchor P0–P5), styled with Bridge45 `.ev-*` classes. */

export type EvidenceDef = {
  id: string;
  name: string;
  line: string;
  note: string;
  weight: number;
  /** CSS modifier mapped to Bridge45 `.ev-E*` / `.ev-ACT` */
  evClass: string;
};

export const PARTNERSHIP_EVIDENCE: EvidenceDef[] = [
  {
    id: 'P0',
    name: 'Hypothesis',
    line: 'We think the organization could be useful.',
    note: 'No credit',
    weight: 0,
    evClass: 'E0',
  },
  {
    id: 'P1',
    name: 'Contact',
    line: 'Reply, introduction, or meeting booked.',
    note: 'Networking',
    weight: 1,
    evClass: 'E1',
  },
  {
    id: 'P2',
    name: 'Fit confirmed',
    line: 'Relevant overlap explicitly confirmed.',
    note: 'Weak',
    weight: 2,
    evClass: 'E2',
  },
  {
    id: 'P3',
    name: 'Resources engaged',
    line: 'Teams, intros, architecture, or a use case engaged.',
    note: 'Emerging leverage',
    weight: 3,
    evClass: 'E3',
  },
  {
    id: 'P4',
    name: 'Concrete commitment',
    line: 'Written package, committed intro, pilot terms, or resources.',
    note: 'Strong signal',
    weight: 4,
    evClass: 'E4',
  },
  {
    id: 'P5',
    name: 'Binding leverage',
    line: 'Funding, signed execution, live pilot, customer, or agreement.',
    note: 'Outcome',
    weight: 5,
    evClass: 'E5',
  },
];

export const EVIDENCE_BY_ID: Record<string, EvidenceDef> = Object.fromEntries(
  PARTNERSHIP_EVIDENCE.map((e) => [e.id, e]),
);

/** Accept P0–P5 or Bridge45 E0–E5 / ACT. */
export function resolveEvidence(level: string | undefined): EvidenceDef {
  const raw = String(level || 'P0');
  if (EVIDENCE_BY_ID[raw]) return EVIDENCE_BY_ID[raw]!;
  const mapped = raw.replace(/^E/, 'P');
  if (EVIDENCE_BY_ID[mapped]) return EVIDENCE_BY_ID[mapped]!;
  return EVIDENCE_BY_ID.P0!;
}
